import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { TagItem } from 'components';
import { Icon } from 'semantic-ui-react';
import { IconButton } from 'material-ui';

import styles from './TagInitial.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

// 각 태그의 이니셜로 묶음
const TagInitial = ({
  // 이니셜 값
  initialKey,
  // 이니셜별 태그 데이터
  tagInitial,
  // 이니셜 영역 열기/닫기
  onToggleTagInitial,
  // 이니셜 열기/닫기 상태 값
  isView,
  // 현재 선택된 태그
  currentTag,
  // 편집 모드
  isEditMode,
  // 태그로 전달한 데이터
  tagItemProp,
  // 태그 카운트 표기 여부
  noTagCount
}) => {
  const tagItemComponent = tagInitial.map(
    // 컴포넌트로 매핑
    tagItem =>
      !!tagItem &&
      !(typeof tagItem.get('isView') !== 'undefined' && !tagItem.get('isView')) && (
        <TagItem
          key={String(tagItem.get('tagNo'))}
          tagItem={tagItem}
          currentTag={currentTag}
          isEditMode={isEditMode}
          tagItemProp={tagItemProp}
          isTargetCount={!!noTagCount ? false : true}
        />
      )
  );

  return (
    <div className={cx('TagInitial-wrapper')}>
      <div className={cx('TagInitial-title')}>
        <div className={cx('title-text')}>{initialKey}</div>
        <div className={cx('bt-toggleView-area')}>
          <IconButton
            color="primary"
            className={cx('bt-toggleView')}
            onClick={() => {
              onToggleTagInitial(initialKey);
            }}>
            <Icon name={isView ? 'chevron up' : 'chevron down'} size="mini" />
          </IconButton>
        </div>
      </div>
      <div className={cx('tagItem-content')}>{isView && tagItemComponent}</div>
    </div>
  );
};

TagInitial.propTypes = {
  // tagInitial: ImmutablePropTypes.listOf({}),
  isView: PropTypes.bool,
  currentTag: ImmutablePropTypes.mapContains({}),
  isEditMode: PropTypes.bool,
  noTagCount: PropTypes.bool
};
TagInitial.defaultProps = {};

export default TagInitial;



// WEBPACK FOOTER //
// ./src/script/components/tag/TagInitial.js